module.exports = __webpack_public_path__ + "img/ill-home-partners-header.ba73e130.svg";